export const environment = {
  production: true,
  AuthUrl: 'https://auth.cobatab.edu.mx',
  url: 'https://academiasemsad.cobatab.edu.mx',
  urlFile: 'https://file.cobatab.edu.mx',
};
